/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Evgenij Tyan
 * @version 1.0.1
 * @since 1.0.0
 */

import IBasketTranslation from '../../types/common/basket';

const initTranslationBasket: IBasketTranslation = {
    applyBtn: '',
    checkedNum: '',
    closeBtn: '',
    counterFrom: '',
    counterTo: '',
    noSearchMatcher: '',
    searchPlaceholder: '',
    selectAll: '',
    title: '',
};

export default initTranslationBasket;
